import { useDrag, ConnectDragPreview, ConnectDragSource } from 'react-dnd';
import { useDispatch } from 'react-redux';
import { DragSourceType, EntityType } from 'const';
import { toggleDragState } from 'containers/App/actions';
import * as Models from 'models';
import { isAssetsCollectionDraggable } from 'utils/isAssetsCollectionDraggable';

type AssetsCollectionDragSourceHook = {
  isDragging: boolean;
  draggable: boolean;
  connectDragSource: ConnectDragSource;
  connectDragPreview: ConnectDragPreview;
};

export const useAssetsCollectionDragSource = (document: Models.AssetsCollectionMap): AssetsCollectionDragSourceHook => {
  const dispatch = useDispatch();
  const dragSourceType = DragSourceType.STORY_CARD;
  const componentType = EntityType.STORY_CARD;
  const [{ isDragging, draggable }, connectDragSource, connectDragPreview] =
    useDrag<Models.StoryCardDragObject, void, { isDragging: boolean; draggable: boolean }>({
      type: dragSourceType,
      item: () => {
        dispatch(toggleDragState(dragSourceType, componentType));

        return {
          storyCardId: (document as unknown as Models.DocumentMap).get('id'),
        };
      },
      canDrag() {
        return isAssetsCollectionDraggable(document);
      },
      collect: monitor => ({
        isDragging: monitor.isDragging(),
        draggable: monitor.canDrag(),
      }),
      end() {
        dispatch(toggleDragState());
      },
    });

  return { isDragging, draggable, connectDragSource, connectDragPreview };
};
